import { ReactElement } from 'react';
import { AppDispatch, RootState } from 'redux/store';

import { updateBreakpoints } from 'services/AccordionService'
import {
  PAGE_RENDER_LEFT,
  SET_PAGE_LEFT,
  SET_PAGE_OVERLAY,
  SET_PAGE_VIEW,
  SET_IS_MOUSE_ABILITY_OPEN,
  SET_PAGE_PARAMETERS
} from './types'

export const setPageLeft = (left: ReactElement) => ({
  type: SET_PAGE_LEFT,
  left
})

export const pageRenderLeft = (component: ReactElement) => ({
  type: PAGE_RENDER_LEFT,
  component
})

export const setIsMouseAbilityOpen = (isMouseAbilityOpen: boolean) => ({
  type: SET_IS_MOUSE_ABILITY_OPEN,
  isMouseAbilityOpen
})

export const setPageView = (pageView: string) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const { page } = getState()

    if ((page.pageView === 'left' && page.left) || page.pageView !== pageView) {
      dispatch({
        type: SET_PAGE_VIEW,
        pageView
      })
    }
  }
}

export const pageToggleSide = (side:string, force: boolean) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    if (force !== null && typeof force === 'boolean') {
      dispatch(setPageView((force && side) || 'main') as any)
    } else {
      const { pageView } = getState().page
      dispatch(setPageView(pageView !== side ? side : 'main') as any)
    }
  }
}

export const pageToggleLeft = (force:boolean = false) => {
  return (dispatch:AppDispatch, _:any) => dispatch(pageToggleSide('left', force) as any)
}

export const pageToggleRight = (force:boolean = false) => {
  return (dispatch:AppDispatch, _:any) => {
    dispatch(pageToggleSide('right', force) as any)
    dispatch(setIsMouseAbilityOpen(force === true))
  }
}

export const pageToggleOverlay = (overlay: ReactElement|null = null) => {
  return (dispatch:AppDispatch, _:any) => {
    updateBreakpoints(overlay)
    dispatch({
      type: SET_PAGE_OVERLAY,
      overlay
    })
  }
}

export const setPageParameters = (pageParameters: any) => {
  return (dispatch:AppDispatch) => {
    dispatch({ type: SET_PAGE_PARAMETERS, pageParameters })
  }
}
